<template>
  <div class="col-12 col-lg-6" @click="$emit('click')">
    <div class="row m-0 p-0" :class="{ 'border-purple' : isSelected, 'deselected-border': !isSelected }">

      <div class="col-12 bg-purple d-flex flex-column justify-content-center text-white p-3">
			  <span class="mr-1 custom-control custom-control-purple custom-checkbox">
				  <input type="checkbox" class="custom-control-input" name="frequency"
						 :id="'frequency' + frequency" :checked="isSelected" @click.prevent>
				  <label class="custom-control-label" :for="'frequency' + frequency" @click="$emit('click')">
					  <h3 class="d-inline-block p-0 m-0">{{ title }}</h3>
				  </label>
			  </span>
      </div>

      <div class="col-12 d-flex flex-column flex-wrap m-0 p-3" :class="{'bg-purple-light' : isSelected}">

        <div v-for="item in plans"
             class="custom-control custom-control-purple custom-checkbox py-1">
          <input :id="item.planId"
                 class="custom-control-input donationOption"
                 type="radio" name="donate-amount"
                 :data-plan="item.planId"
                 :data-sponsor="profile.name"
                 :value="item.amount"
                 v-model="selectedAmount"
                 @click="setSelectedPlan(item)"
          >
          <label class="custom-control-label" :for="item.planId">
            <span v-if="item.amount > 0">&pound;</span>{{ item.label }} <span v-if="item.amount === minAmount"><small>(Minimum)</small></span>
          </label>
        </div>


        <div v-if="showOther"
             class="custom-control custom-control-purple custom-checkbox py-1 pl-0 limit-width">
          <label class="sr-only" :for="customFieldId">Custom donation
            amount</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">&pound;</div>
            </div>
            <input :id="customFieldId" class="form-control" type="number"
                   :min="minAmount"
                   max="9999"
                   v-model.sync="otherAmount"
				   v-on:change="updateOtherAmount"
            >
            <div class="input-group-append">
              <span class="input-group-text">.00</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
	name: 'pricebox',
	props: {
		title: String,
		plans: Array,
		profile: Object,
		frequency: String,
		defaultPlan: Number,
		customAmount: Number,
		isSelected: Boolean
	},
	data: function () {
		return {
			selectedPlan: null,
			selectedAmount: null,
			otherAmount: 60,
			defaultSelectedPlan: null,
			showOther: false
		}
	},
	computed: {
		minAmount: function () {
			return Math.min(...this.plans.filter(plan => {
				if (plan.amount > 0) {
					return plan.amount
				}
			}).map(plan => plan.amount))
		},
		customFieldId: function () {
			return 'custom-' + this.frequency
		}
	},

	methods: {
		setSelectedPlan: function (plan) {
			if (plan.amount === 0) {
				this.showOther = true
				if (this.frequency === 'monthly') {
					// 'other' plan must have a unique plan id
					let parts = plan.planId.split('-')
					parts = parts.splice(0, (parts.length - 1))
					parts.push(this.otherAmount)
					plan.planId = parts.join('-')
				}
				this.selectedPlan = plan.planId
				this.$emit('selectPlan', { plan: this.selectedPlan, frequency: this.frequency, amount: this.otherAmount })
			} else {
				this.showOther = false
				this.selectedPlan = plan.planId
				this.selectedAmount = plan.amount
				this.$emit('selectPlan', { plan: this.selectedPlan, frequency: this.frequency, amount: this.selectedAmount })
			}
		},
		updateOtherAmount: function () {
			this.setSelectedPlan({ planId: this.selectedPlan, frequency: this.frequency, amount: 0 })
		}
	},
	created () {
		if (this.defaultPlan) {
			const defaultSelectedPlan = this.plans.find(plan => plan.amount === this.defaultPlan)
			this.defaultSelectedPlan = defaultSelectedPlan
			this.setSelectedPlan(defaultSelectedPlan)
		}
		this.otherAmount = this.customAmount
	},

	watch: {

	}
}
</script>

<style scoped>

.deselected-border {
	border: solid 2px transparent;
}

.selected-border {
	border: solid 2px #877aaa;
}

@media (min-width: 992px) {
	.limit-width {
	  max-width: 160px;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/sponsorform/pricebox.vue